var app = angular.module("discipline-app", []);
module.exports = app;